import React from 'react';
import { Typography } from 'antd';

import { useTranslation } from 'react-i18next';

export const EduInfoCard = ({ eduInfo }) => {
  const { t } = useTranslation();

  if (!eduInfo?.lastName) {
    return null;
  }

  return (
    <div style={{ marginTop: '1rem' }}>
      <div>
        <Typography.Text strong>
          {eduInfo.lastName} {eduInfo.firstName}
        </Typography.Text>
        <br />
        <br />

        {['pupil', 'student'].includes(eduInfo.type) ? (
          <>
            <Typography.Text>
              {eduInfo.type === 'pupil'
                ? t('entity.pos.eduInfo.pupilAt')
                : t('entity.pos.eduInfo.studentAt')}
            </Typography.Text>
            <br />
            <Typography.Text>{eduInfo.schoolName}</Typography.Text>
            <br />
            <Typography.Text>
              {eduInfo.localityName}, {eduInfo.countyName}
            </Typography.Text>
            <br />
            <Typography.Text>{eduInfo.className}</Typography.Text>
            <br />
            <br />
            {eduInfo?.schoolYear && (
              <>
                <Typography.Text>{eduInfo.schoolYear}</Typography.Text>
                <br />
              </>
            )}
            {eduInfo?.studyStatus && (
              <Typography.Text>{eduInfo.studyStatus}</Typography.Text>
            )}
          </>
        ) : (
          <Typography.Text>{eduInfo.studyStatus}</Typography.Text>
        )}
      </div>
    </div>
  );
};
